<div
  class="video-wrapper {{ classes }}"
  [innerHTML]="sanitizeHtml(iframe?.rawData.html)"
></div>
